import axios from "axios";

const agencyMarketplace = {
  namespaced: true,
  state: {
    sharedWith: null,
    sharingErrors: null,
    showSharingModal: false,
  },
  getters: {
    sharedWith: ({sharedWith}) => sharedWith,
    sharingErrors: ({sharingErrors}) => sharingErrors,
    showSharingModal: ({showSharingModal}) => showSharingModal,
  },
  mutations: {
    setSharedWith(state, sharedWith) {
      state.sharedWith = sharedWith;
    },
    setSharingErrors(state, sharingErrors) {
      state.sharingErrors = sharingErrors;
    },
    setShowSharingModal(state, showSharingModal) {
      state.showSharingModal = showSharingModal;
    }
  },
  actions: {
    shareWebsite: async (context, {shareCode}) => {
      const response = await axios.post('/website/share', {
        organisationUuid: shareCode
      }).catch(error => {
        if (error?.response?.status === 422) {
          context.commit('setSharingErrors', error?.response?.data?.message);
        } else {
          context.dispatch('sharedWith');
          context.commit('setSharingErrors', null);
        }
    });
    await context.dispatch('sharedWith');
    },
    revokeWebsiteAccess: async (context, {shareCode}) => {
      await axios.post('/website/revoke-access', {
        organisationUuid: shareCode
      }).catch(error => error);
      await context.dispatch('sharedWith');
    },
    sharedWith: async (context) => {
      const response = await axios.get(`/website/shared-with`);
      context.commit('setSharedWith', response.data.data.sharedWith);
    },
    setShowSharingModal: (context, showSharingModal) => {
      context.commit('setShowSharingModal', showSharingModal);
    },
    /**
     * When a single user shared the website with an agency this is the call agency user needs to make to
     * impersonate that single user in order to gain access tht their website.
     */
    async impersonate(context, {websiteId, uri}) {
      await axios.post('/agency/marketplace/impersonate', {websiteId});
      window.location.href = uri ?? '/dash';
    }
  }
};

export default agencyMarketplace;
